import { render, staticRenderFns } from "./integral_detail.vue?vue&type=template&id=094e84c0&scoped=true"
import script from "./integral_detail.vue?vue&type=script&lang=js"
export * from "./integral_detail.vue?vue&type=script&lang=js"
import style0 from "./integral_detail.vue?vue&type=style&index=0&id=094e84c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e84c0",
  null
  
)

export default component.exports